import './App.css';
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NewsTicker from "./components/NewsTicker";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ResumePage from "./components/ResumePage";
import IPTracker from "./test/IPTracker";

// Import your page components
import Home from "./pages/Home";
import About from "./pages/About";
import Analytics from "./pages/Analytics";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";

function App() {
  return (
    <Router>
      <div className="app-container">
        <NewsTicker />
        <Navbar />

        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/resume" element={<ResumePage />} />
            <Route path="/test" element={<IPTracker />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;


